<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-22 16:13:24
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-06-07 14:40:10
-->
<template>
  <div class="innovative innovative-acculv" :class="{textj: language != 'en'}" ref="acculv">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.acculv.title')"></div>
    </div>
    <div class="p-t-50 p-b-10">
      <div class="p-l-30 p-r-30">
        <div class="innovative-item-title p-l-25" v-html="$t('product.acculv.list[0].title')"></div>
      </div>
      <div class="p-t-28 p-l-30 p-r-15">
        <img class="wid100" :src="$t('product.acculv.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 textj">
        <p class="p-t-20 p-b-20" v-for="item, index in $t('product.acculv.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div>
      <div class="acculv-characteristics">
        <div class="innovative-container">
          <div class="innovative-item-title" v-html="$t('product.acculv.list[1].title')"></div>
          <div class="acculv-characteristics-box">
            <div class="p-t-20 p-b-40" v-for="item, index in $t('product.acculv.list[1].des')" :key="index">
              <div class="p-b-20 textc">
                <img class="acculv-characteristics-img" :src="item.img" alt="" srcset="">
              </div>
              <div class="innovative-wrap-item-title textc fz-30 p-b-25">
                <p v-for="$item, $index in item.title" :key="$index" v-html="$item"></p>
              </div>
              <div v-for="$item, $index in item.list" :key="$index">
                <p class="innovative-characteristics-item ilblk" v-html="$item"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="acculv-advantages">
      <div>
        <div class="innovative-item-title" v-html="$t('product.acculv.list[2].title')"></div>
        <div class="innovative-acculv-m-h clearfix flex flex_wrap">
          <div class="flex innovative-acculv-m-h-item" v-for="item, index in $t('product.acculv.list[2].des')" :key="index">
            <div class="p-r-40">
              <img class="acculv-characteristics-img" :src="item.img" alt="" srcset="">
            </div>
            <div class="flex_1">
              <div class="innovative-wrap-item-title fz-28 p-b-10" v-html="item.title"></div>
              <div>
                <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="textc p-t-50">
          <img class="wid100" :src="$t('product.acculv.list[2].img')" alt="" srcset="">
          <p class="fz-20 fontw p-t-20" v-html="$t('product.acculv.list[2].imgDes')"></p>
        </div>
      </div>
    </div>
    <div class="innovative-container">
      <div class="p-t-20 article">
        <div class="innovative-item-title" v-html="$t('product.acculv.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.acculv.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-acculv {
  .acculv-characteristics {
    background-image: url('~@/assets/images/innovate/AccuLV/m_2.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
    padding: 20px 0;
    .acculv-characteristics-box {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 50px;
    }
    .acculv-characteristics-img {
      max-height: 80px;
    }
  }
  .acculv-advantages {
    background: #F8FBFF;
    border-radius: 8px;
    padding: 50px 30px;
  }
  .innovative-acculv-m-h {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
    padding: 0 30px;
    .innovative-acculv-m-h-item {
      padding: 40px 0;
      img {
        max-width: 100px;
      }
    }
  }
}
</style>
